import React from 'react'
import laptop from '../assests/img/computer.jpg'
export default function Expert() {
    return (
        <div className=' max-h-[1240px] mx-auto my-10 py-10 p-2 md:grid grid-cols-2 '>
            <div className=" col-span-1 md:w-[80%]  py-10  left-[140px]   ">
                <img src={laptop} alt="loading image ..." className='     md:pl-[100px] rounded ' />
            </div>

            <div className="  py-8 col-span-1">
                <h1 className=' text-3xl font-bold pb-3 text-[#00dfa9]'>Learn From Experts</h1>
                <p className=' text-justify mr-5'>Lorem ipsum, dolor sit amet consectetur Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit necessitatibus facere, molestias, assumenda quidem perferendis debitis, repudiandae sapiente velit saepe excepturi nulla! Quibusdam, vitae. Numquam adipisci non ullam ut velit? adipisicing elit. Ullam praesentium vitae odit voluptatum est reiciendis repellendus veniam eaque officia architecto ducimus consectetur alias enim voluptates ipsam dicta, laudantium doloribus doloremque.</p>

                <button className=' bg-black hover:bg-blue-500 text-white font-bold py-2 my-4 px-4 border border-blue-700 rounded'>Get Started</button>
            </div>


        </div>
    )
}
